import { Github, Linkedin, Mail } from "lucide-react";
import { profile } from "../data/mock";

export const Footer = () => {
  return (
    <footer
      className="relative py-10 border-t border-white/5"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div>
          <p className="font-display text-sm font-semibold tracking-tight">
            <span className="text-white">{profile.name}</span>
            <span className="text-gradient-aurora">.</span>
          </p>
          <p className="font-mono text-[11px] uppercase tracking-widest text-cyan-200/60 mt-1">
            AI/ML Engineer · LLM Systems · {new Date().getFullYear()}
          </p>
        </div>

        <div className="flex items-center gap-3">
          <a
            href={`mailto:${profile.email}`}
            aria-label="Email"
            className="inline-flex items-center justify-center h-9 w-9 rounded-full glass text-cyan-300 hover:text-white hover:bg-white/10 transition-colors duration-200"
            data-testid="footer-email"
          >
            <Mail className="h-4 w-4" />
          </a>
          <a
            href={profile.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            className="inline-flex items-center justify-center h-9 w-9 rounded-full glass text-cyan-300 hover:text-white hover:bg-white/10 transition-colors duration-200"
            data-testid="footer-linkedin"
          >
            <Linkedin className="h-4 w-4" />
          </a>
          <a
            href={profile.github}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub"
            className="inline-flex items-center justify-center h-9 w-9 rounded-full glass text-pink-300 hover:text-white hover:bg-white/10 transition-colors duration-200"
            data-testid="footer-github"
          >
            <Github className="h-4 w-4" />
          </a>
        </div>

        <p className="font-mono text-[11px] text-cyan-200/50">
          Designed & built with intent.
        </p>
      </div>
    </footer>
  );
};
